import { render } from "./IqraStudentSlotEnrollmentManagement.vue?vue&type=template&id=ecb79a14"
import script from "./IqraStudentSlotEnrollmentManagement.vue?vue&type=script&lang=js"
export * from "./IqraStudentSlotEnrollmentManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__